'use strict';

/**
 * Layout for a conversation
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CollectionView = require('base/Colido.CollectionView');
var ConversationPostsListItemView = require('./conversation-post');
var ConversationPostsListEmptyView = require('./conversation-post-empty');

var ConversationPostsListView = CollectionView.extend({
    tagName: 'ol',

    childView: ConversationPostsListItemView,

    emptyView: ConversationPostsListEmptyView,

    className: 'conversation-posts',
});

module.exports = ConversationPostsListView;